import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useContext } from "react";
import PermContact from "src/assets/svg/permcontact.js";
import { Box, Typography, Button, Divider } from "@mui/material";
import { getPageRoute } from "src/services";
import { customEvent } from "src/utils/gtag.js";
import UAParser from "ua-parser-js";
import InstructionsLayout from "../InstructionsLayout.js";
import { AuthContext } from "src/utils/AuthContext.js";

const GoogleCalendarExperience = () => {
  const location = useLocation();
  const calendar = location.state?.calendar ?? null;
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const uaParser = new UAParser();
  const parserResults = uaParser.getResult();

  const isDesktop = !parserResults.device.type;

  useEffect(() => {
    if (!calendar) {
      navigate(getPageRoute("home", "HOME"));
    }
  }, [calendar, navigate]);

  const handleGoogleCalendarConnect = () => {
    customEvent({
      name: "nav_google_calendar_steps_experience_page",
      category: "GoogleCalendarExperience",
      label: "Navigate to Google Calendar Steps from Experience Page",
      data: {
        user_id: user._id,
        user_email: user.email,
        user_handle: user.handle ?? "no_handle",
      },
    });
    navigate(getPageRoute("help", "SUBSCRIBING_GOOGLE_CALENDAR_STEPS"));
  };

  const handleSubscribeExperience = () => {
    navigate(getPageRoute("help", "SUBSCRIBING_CALENDAR_EXPERIENCE"), {
      state: { calendar },
    });
  };

  return (
    <InstructionsLayout nav="home">
      <PermContact />
      <Typography variant={"h2"} sx={{ mt: 1.5 }}>
        {isDesktop ? (
          <>
            Events will not appear in your <br /> Google Calendar app on
            mobile
          </>
        ) : (
          "Google Calendar App doesn't support new calendar subscriptions"
        )}
      </Typography>
      <Typography variant={"subtitle2"} sx={{ mt: 1.5 }}>
        {isDesktop ? (
          <>
            Google requires you to manually sync <br />new calendar
            subscriptions on mobile.
          </>
        ) : (
          "You can only subscribe to new calendars on the web and need to manually sync on mobile."
        )}
      </Typography>
      <Button
        variant="contained"
        size="grown"
        sx={{ mt: 6, width: "330px" }}
        onClick={handleGoogleCalendarConnect}
      >
        CONNECT GOOGLE CALENDAR
      </Button>
      <Typography
        variant={"subtitle2"}
        sx={{
          mt: 2,
          width: "330px",
        }}
      >
        Break free from Google's limitations and <br />add events across{" "}
        <u>all your devices</u> seamlessly.
      </Typography>
      <Box sx={{ width: "100%", maxWidth: "330px" }}>
        <Divider sx={{ mt: 3, mb: 3.5 }}>
          <Typography variant="subtitle2" color="text.secondary">
            or
          </Typography>
        </Divider>
      </Box>

      <Button
        variant="outlined"
        size="grown"
        sx={{ width: "330px" }}
        onClick={handleSubscribeExperience}
      >
        SUBSCRIBE ON DESKTOP & SYNC
      </Button>
      <Typography
        variant={"subtitle2"}
        sx={{
          mt: 2,
          width: "330px",
        }}
      >
        Subscribe on desktop and <u>manually sync</u> with your Google Calendar
        app on every mobile device.
      </Typography>
    </InstructionsLayout>
  );
};

export default GoogleCalendarExperience;
